import React from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function ViewTrendBlog({ blog, show, onHide }) {
  const handleClose = () => onHide();

  return (
    <>
      <Modal
        show={show}
        className="custom-modal"
        size="lg"
        centered
        scrollable
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>View Recipe Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            <div className="col-12">
              <Form.Label className="mb-0">Recipe Image</Form.Label>
              <div className="text-center mt-3 image-preview d-flex justify-content-center align-items-center position-relative">
                <div className="rounded-3 overflow-hidden h-100 w-100">
                  <img
                    // src={blog.blogImage ? `${process.env.REACT_APP_BACKEND_URL}/${blog.blogImage}` : "-"}
                    src={
                      blog?.phoneImage || blog?.blogImage
                        ? `${process.env.REACT_APP_BACKEND_URL}/${
                            blog?.phoneImage || blog?.blogImage
                          }`
                        : "https://img.freepik.com/premium-photo/adult-beautiful-woman-working-out-light-background_470178-19669.jpg"
                    }
                    alt="Uploaded"
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Title</Form.Label>
              <p>{blog.title ? blog.title : "-"}</p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Credit Source</Form.Label>
              <p>{blog.creditSource ? blog.creditSource : "-"}</p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Created Date</Form.Label>
              <p>
                {blog.createdAt
                  ? new Date(blog.createdAt).toISOString().split("T")[0]
                  : "-"}
              </p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Content</Form.Label>
              <p dangerouslySetInnerHTML={{ __html: blog?.content }}></p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ViewTrendBlog;
